import script from "./MusicView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MusicView.vue?vue&type=script&setup=true&lang=ts"

import "./MusicView.vue?vue&type=style&index=0&id=2595f66c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2595f66c"]])

export default __exports__